<template>
  <el-dialog
    class="wrapper"
    :title="
      state.selectImgOperation !== 'SET_PROGRAM_BG_IMG'
        ? $t('lcd.Editor.Select Image')
        : $t('lcd.Editor.Select Background')
    "
    :visible.sync="dialogVisible"
  >
    <div class="searchWrap">
      <el-input
        v-model="form.materialName"
        size="small"
        :placeholder="$t('lcd.material.Please Input Material Name')"
        @change="handleSearchChange"
        class="searchInput"
        clearable
      ></el-input>
      <el-select
        v-if="templateGroup != '3'"
        size="small"
        v-model="form.groupId"
        @change="handleSearchChange"
        class="searchSelect"
        clearable
        :placeholder="$t('lcd.material.Please Select Material Type')"
      >
        <el-option
          v-for="item in groupList"
          :key="item.codeValue"
          :label="item.codeName"
          :value="item.codeValue"
        ></el-option>
      </el-select>
      <el-select
      v-if="templateGroup != '3'"
        size="small"
        v-model="form.pixels"
        @change="handleSearchChange"
        class="searchSelect"
        :placeholder="$t('lcd.material.Please Select Material Type')"
        clearable
        filterable
      >
        <el-option
          v-for="item in pixelsList"
          :key="item"
          :label="item"
          :value="item"
        ></el-option>
      </el-select>
    </div>
    <!-- {{imgOptions.imageList}} -->
    <div style="padding: 0px">
      <el-row :gutter="18">
        <el-col
          :xs="12"
          :sm="8"
          :md="8"
          :lg="6"
          :xl="6"
          v-for="o in imgOptions.imageList"
          :key="o.id"
          style="margin-bottom: 18px"
        >
          <el-card
            class="elCard"
            shadow="hover"
            :body-style="{ padding: '0 0 50px 0' }"
          >
            <span class="format">{{ o.format || o.imageSize }}</span>
            <div style="width: 100%; padding: 8px 10px; position: relative">
              <div
                class="materialWrap"
                @click="handleSelectImg(o)"
                :style="{
                  cursor: 'pointer',
                  'min-height': '140px',
                  'background-image': 'url(' + o.url || o.originalUrl + ')',
                  'background-size': 'contain',
                  'background-position': 'center',
                  'background-repeat': 'no-repeat',
                }"
              >
                <!-- <img
                  :src="o.url"
                  :style="{ width: '100%', height: 'auto' }"
                  @click="handleSelectImg(o)"
                /> -->
              </div>
            </div>
            <div class="imageName">
              <span>{{ o.materialName || o.imageName }}</span>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <el-pagination
      layout="total, sizes, prev, pager, next"
      :current-page="imgOptions.current"
      :total="imgOptions.total"
      :page-size="imgOptions.size"
      :page-sizes="imgOptions.sizes"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
      background
      style="text-align: right"
      v-if="imgOptions.imageList.length > 0"
    />
    <el-empty
      v-if="imgOptions.imageList.length < 1"
      :image-size="200"
    ></el-empty>
  </el-dialog>
</template>

<script>
import store from "../../../store/index.js";
import { attrMultiImg } from "../../../utils/component-attribute";
import { idxOf } from "../../../utils/common.js";
import eventbus from "../../../utils/eventbus";

import {
  getEslImageColorUrl,   // 获取ESL素材详情url
} from "@/libs/api/lcd";

export default {
  name: "SelectImg",
  inject: ["getNewComponentId"],
  data() {
    return {
      activeName: "1",
      state: store.state,
      form: {
        materialName: "",
        pixels: "",
        groupId: "",
      },
      templateGroup:store.state.programInfo.templateGroup
    };
  },
  props: {
    imgOptions: {
      type: Object,
      default: function () {
        return null;
      },
    },
    groupList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    pixelsList: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return store.state.selectImgDialogVisible;
      },
      set(val) {
        return store.updateSelectImgDialogVisible(val);
      },
    },
  },
  watch: {
    dialogVisible(val, oval) {
      if (val) {
        this.form = {
          materialName: "",
          pixels: "",
          groupId: "",
        };
        this.$emit("init-change", this.form);
      }
    },
    "store.state.selectImgDialogVisible"(val) {
      console.log(val);
    },
  },
  methods: {
    handleCurrentChange(val) {
      this.$emit("current-change", val);
    },
    handleSizeChange(val) {
      this.$emit("size-change", val);
    },
    handleSearchChange() {
      const val = {
        ...this.form,
      };
      this.$emit("search-change", val);
    },
    async handleSelectImg(img) {
      console.log("====", store.state.programInfo.color);
      console.log("====img", img);
      if(this.$route.query.origin == 'esl'){
        const colorFlag = store.state.programInfo.color
        const params = {
          imageId: img.shareSourceId
        }
        await getEslImageColorUrl(params).then(res => {
          console.log(res.data.data.colorImageList)
          const colorImageList = res.data.data.colorImageList
          const colorImageUrl = colorImageList.find(i => i.color == colorFlag)?.imageUrl
          img = {
            ...img,
            url: colorImageUrl
          }
        })
      }
      console.log('啊啊啊啊啊啊',img)
      // console.log(img.pixels.split("*")[0])
      // console.log(img.pixels.split("*")[1])
      const imgWidth = img.pixels ? img.pixels.split("*")[0] : 200;
      const imgHeight = img.pixels ? img.pixels.split("*")[1] : 150;
      // console.log("====img", imgWidth, imgHeight);
      let conf;
      // console.log(attrMultiImg)
      
      switch (store.state.selectImgOperation) {
        case "ADD_COMPONENT":
          // 添加多图组件
          conf = JSON.parse(JSON.stringify(attrMultiImg));
          conf.componentId = this.getNewComponentId();
          conf.imgList.push({
            duration: 3,
            imgSrc: img.url,
            imgId: img.id,
            imgFormat: img.format,
          });
          store.addComponent(conf);
          break;
        case "ADD_IMAGE":
          {
            // 为多图组件添加图片
            const newProgramData = JSON.parse(
              JSON.stringify(store.state.programInfo)
            );
            const idx = idxOf(
              newProgramData.pages[store.state.currentPageIdx].componentList,
              store.state.activeComponent,
              "componentId"
            );
            newProgramData.pages[store.state.currentPageIdx].componentList[
              idx
            ].imgList = [];
            newProgramData.pages[store.state.currentPageIdx].componentList[
              idx
            ].imgList.push({
              duration: 5,
              imgSrc: img.url,
              imgId: img.id,
            });
            newProgramData.pages[store.state.currentPageIdx].componentList[
              idx
            ].width = this.templateGroup == 3 ? img.imageSize.split("*")[0] : parseInt(imgWidth);
            newProgramData.pages[store.state.currentPageIdx].componentList[
              idx
            ].height = this.templateGroup == 3 ? img.imageSize.split("*")[1] : parseInt(imgHeight);
            store.updateProgramInfo(newProgramData);
          }
          break;
        case "SET_PROGRAM_BG_IMG":
          store.setPageBGImg(img.url, img.id);
          // if (store.state.programInfo.pages.length > 1) {
          //   const tmp = store.state.currentPageIdx
          //   store.updateCurrentPageIdx((tmp + 1) % store.state.programInfo.pages.length)
          //   setTimeout(() => {
          //     store.updateCurrentPageIdx(tmp)
          //   }, 0)
          // }
          break;
        default:
          break;
      }
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  ::v-deep .el-dialog {
    width: 1008px;
    margin-top: 5vh !important;
  }
  ::v-deep .el-dialog__header {
    border-bottom: 1px solid #ececf2;
    button {
      font-size: 20px;
    }
  }
  ::v-deep .el-dialog__body {
    padding-top: 0;
  }
  .img-row {
    .el-col {
      width: calc(33.33333% - 12px);
      margin: 6px;
      img {
        cursor: pointer;
      }
    }
  }
}
.searchWrap {
  width: 100%;
  padding: 15px 0;
  .searchInput {
    width: 160px;
  }
  .searchSelect {
    margin-left: 10px;
  }
}
::v-deep .el-pagination.is-background button,
.el-pagination.is-background button span,
.el-pagination.is-background .el-pager li {
  height: 28px !important;
  line-height: 28px !important;
}
::v-deep .el-pagination.is-background .el-pager li {
  height: 28px !important;
  line-height: 28px !important;
}
.elCard {
  position: relative;
  .format {
    // width: 40px;
    font-size: 12px;
    line-height: 16px;
    position: absolute;
    background-color: rgba($color: #000000, $alpha: 0.4);
    padding: 3px 8px;
    color: #fff;
    right: 0;
    top: 0;
    border-radius: 0 3px 0 3px;
    z-index: 2;
  }
}
.imageName {
  padding: 5px 10px;
  height: 50px;
  // background-color: rgba(0, 0, 0,.2);
  // color:#fff;
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 0;
  left: -1px;
  right: -1px;
  z-index: 2;
  font-size: 13px;
  line-height: 16px;
}
</style>
